export interface  OldSchool{
    academic_year:string,
    classroom:string,
    school_name:string,
    system:string,
    country:string,
    system_precision:string
    }
export interface  Family{
    identity:string,
    birthdate:string,
    classroom:string,
    school:string
    }
    

export const  FamilyForm={
identity:"",
birthdate:"",
classroom:"",
school:""
}

export const  OldSchoolForm={
    academic_year:"",
    classroom:"",
    school_name:"",
    system:"",
    system_precision:"",
    country:""
    }
export const  OldSchoolList:OldSchool[]=[]
export const  familyList:Family[]=[]

export const InscriptionForm:any={
student:{
firstname:"",
lastname:"",
birthdate:"",
birthplace:"",
address:"",
photo:"",
observation:"",
sex:"",
email:"",
languages:"",
origin:"",
parent:{
    father_lastname:"",
    father_firstname:"",
    father_email:"",
    father_address:"",
    father_job:"",
    father_phone:"",
    mother_lastname:"",
    mother_firstname:"",
    mother_email:"",
    mother_address:"",
    mother_job:"",
    mother_phone:"",
    tutor_lastname:"",
    tutor_firstname:"",
    tutor_email:"",
    tutor_address:"",
    tutor_job:"",
    tutor_phone:"",
    families:familyList
},
classroom:""
},
old_schools:OldSchoolList,
has_paid:null,
documents:[]
}